import type {
  CreateQuestionInput, DraftRevisionInput, PublishQuestionDraftInput,
  PublishQuestionVersionInput, QbankMedia, QbankTaxonomy, QuestionBank, QuestionDetail, QuestionListQuery,
  QuestionListResult, SaveQuestionDraftInput, StartQuestionDraftInput
} from "@pustak-lms/contracts";

export function qbankClient(request: <T>(path: string, init?: RequestInit) => Promise<T>) {
  const base = "/api/platform/qbank";
  const question = (id: string) => `${base}/questions/${encodeURIComponent(id)}`;
  const post = <T>(path: string, body: unknown = {}) => request<T>(path, { method: "POST", body: JSON.stringify(body) });
  return {
    qbankTaxonomy: () => request<QbankTaxonomy>(`${base}/taxonomy`),
    qbankBanks: () => request<QuestionBank[]>(`${base}/banks`),
    listQuestions: (query: QuestionListQuery = {}) => {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(query)) if (value !== undefined && value !== "") params.set(key, String(value));
      return request<QuestionListResult>(`${base}/questions${params.size ? `?${params}` : ""}`);
    },
    getQuestion: (id: string) => request<QuestionDetail>(question(id)),
    createQuestion: (input: CreateQuestionInput) => post<QuestionDetail>(`${base}/questions`, input),
    startQuestionDraft: (id: string, input: StartQuestionDraftInput = {}) => post<QuestionDetail>(`${question(id)}/draft/start`, input),
    saveQuestionDraft: (id: string, input: SaveQuestionDraftInput) => post<QuestionDetail>(`${question(id)}/draft/save`, input),
    discardQuestionDraft: (id: string, input: DraftRevisionInput) => post<QuestionDetail>(`${question(id)}/draft/discard`, input),
    publishQuestionDraft: (id: string, input: PublishQuestionDraftInput) => post<QuestionDetail>(`${question(id)}/draft/publish`, input),
    publishQuestionVersion: (id: string, input: PublishQuestionVersionInput) => post<QuestionDetail>(`${question(id)}/versions/publish`, input),
    unpublishQuestionExam: (id: string, examId: string) => post<QuestionDetail>(`${question(id)}/exams/${encodeURIComponent(examId)}/unpublish`),
    uploadQuestionImage: (file: File) => request<QbankMedia>(`${base}/media?${new URLSearchParams({ name: file.name })}`, {
      method: "POST", headers: { "Content-Type": file.type }, body: file
    })
  };
}
